import { useQueryClient as t, useMutation as d } from "@tanstack/react-query";
import l from "./onboarding.api.js";
import { teachurKeys as c } from "../../constants/teachurKeys.js";
const U = (r) => {
  const a = t();
  return d({
    mutationFn: async (u) => l.updateOnboarding(u),
    onMutate: async (u) => {
      await a.cancelQueries({ queryKey: c.users.currentUser() });
      const n = a.getQueryData(c.users.currentUser());
      return a.setQueryData(c.users.currentUser(), (e) => !e || !e.onboarding ? e : {
        ...e,
        onboarding: { ...e.onboarding, ...u }
      }), { previousUser: n };
    },
    onError: (u, n, e) => {
      var s;
      e != null && e.previousUser && a.setQueryData(c.users.currentUser(), e.previousUser), (s = r == null ? void 0 : r.onError) == null || s.call(r, u, n, e);
    },
    onSuccess: (u, n, e) => {
      var s;
      a.setQueryData(c.users.currentUser(), u), (s = r == null ? void 0 : r.onSuccess) == null || s.call(r, u, n, e);
    },
    meta: {
      successMessage: "Onboarding updated successfully",
      errorMessage: "Failed to update onboarding"
    }
  });
}, b = (r) => {
  const a = t();
  return d({
    mutationFn: async (u) => l.uploadOnboardingFile(u),
    onSuccess: () => {
      a.invalidateQueries({ queryKey: c.users.currentUser() });
    },
    meta: {
      successMessage: "File uploaded successfully",
      errorMessage: "Failed to upload file"
    },
    ...r
  });
}, m = (r) => {
  const a = t();
  return d({
    mutationFn: async (u) => l.deleteOnboardingFile(u),
    onMutate: async (u) => {
      await a.cancelQueries({ queryKey: c.users.currentUser() });
      const n = a.getQueryData(c.users.currentUser());
      return a.setQueryData(c.users.currentUser(), (e) => {
        if (!e)
          return;
        const s = `idImage${u.index}`;
        return {
          ...e,
          onboarding: {
            ...e.onboarding,
            [s]: null
          }
        };
      }), { previousUser: n };
    },
    onError: (u, n, e) => {
      var s;
      e != null && e.previousUser && a.setQueryData(c.users.currentUser(), e.previousUser), (s = r == null ? void 0 : r.onError) == null || s.call(r, u, n, e);
    },
    onSuccess: (u, n, ...e) => {
      var s;
      (s = r == null ? void 0 : r.onSuccess) == null || s.call(r, u, n, ...e);
    },
    meta: {
      successMessage: "File deleted successfully",
      errorMessage: "Failed to delete file"
    }
  });
};
export {
  m as useDeleteOnboardingFileMutation,
  U as useUpdateOnboardingMutation,
  b as useUploadOnboardingFileMutation
};
